import styled from "styled-components";

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        padding: 96px 24px;
        gap: 72px;
    `,

    "Header": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 24px;

        & > h2 {
            ${({ theme }) => theme.font["large-medium"]};
        }
    `,

    "ContentDiv": styled.div`
        display: flex;
        flex-direction: column;
        gap: 32px;
    `,
    "Area": styled.div`
        display: flex;
        flex-direction: column;
        gap: 8px;

        & > h2 {
            width: 100%;
            ${({ theme }) => theme.font["medium-medium"]};
            color: ${({ theme }) => theme.color["grey3"]};
            padding-bottom: 8px;
            border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};
        }

        & > p {
            ${({ theme }) => theme.font["medium-regular"]};
        }
    `,
}